import { authRoutes } from './authentication';
import { hqAdministrationRoutes } from './hqAdministration';
import { memberToolsRoutes } from './memberTools';
import { documentationRoutes } from './documentation';
import { salesAdministrationRoutes } from './salesAdministration';
import { siteAdministrationRoutes } from './siteAdministration';
import { systemRoutes } from './system';

import logoIcon from '@/icons/logos/nerdLogo.svg';
import resetIcon from '@/icons/fontawesome/lock-solid.svg';
import { brand } from '@/brand/brand';

export const routes = {
  ...authRoutes,
  ...hqAdministrationRoutes,
  ...memberToolsRoutes,
  ...documentationRoutes,
  ...salesAdministrationRoutes,
  ...siteAdministrationRoutes,
  ...systemRoutes,
  forgotPassword: {
    path: '/forgot-password',
    key: 'forgot-password',
    value: 'Forgot Password',
    QADataTag: 'forgotPasswordNav',
  },
  home: {
    path: `${brand.loggedOutHomeRoute}`,
    key: 'home',
    value: 'Home',
    icon: logoIcon.src,
    QADataTag: 'homeNav',
  },
  loggedInHome: {
    path: `${brand.loggedInHomeRoute}`,
    key: 'home',
    value: 'Home',
    icon: logoIcon.src,
    QADataTag: 'settingsNav',
  },
  resetPassword: {
    path: '/reset-password',
    key: 'reset-password',
    value: 'Reset password',
    icon: resetIcon.src,
    QADataTag: 'resetPasswordNav',
  },
};
